import React, { useState, useEffect, useContext, useRef} from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import './App.css';
import {submitLogin} from './api'
import { AuthContext } from './AuthContext';

function Landing() {
  const navigate = useNavigate();
  const { login, logout } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const [text, setText] = useState('');
  const fullText = 'Welcome. Enter the super secret key to proceed... ';
  const [password, setPassword] = useState('');
  const inputRef = useRef(null);


  useEffect(() => {
    logout()  // logout user on load (we do not want to re-use stored tokens for simplicity)
    let index = 0;
    const interval = setInterval(() => {
      setText(fullText.slice(0, index + 1));
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, 75);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async () => {
    try {
      const res = await submitLogin( { password: password });
      login(res.access_token);

      // Redirect based on role
      if (user.sub === 'admin') {
        navigate('/admin');
      } else {
        navigate('/home');
      }
    } catch (e) {
      console.log(e)
      alert('Access Denied!');
    }
  };

  return (
    <div className="app-container">
      <div
        className="box"
        style={{
          maxWidth: '100vw',
          boxSizing: 'border-box',
          padding: '2rem',
        }}
      >
        <h1 className="typewriter">{text}</h1>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="super secret key..."
          className="input"
        />
        <button className="enter-button" onClick={handleSubmit}>
          Enter
        </button>
      </div>
    </div>
  );
}

export default Landing;
